import { render } from "./IconClock.vue?vue&type=template&id=988d133e"
import script from "./IconClock.vue?vue&type=script&lang=js"
export * from "./IconClock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__